<template>
  <div id="app">
      <!-- <Index></Index> -->
      <router-view></router-view>
  </div>
</template>

<script>
import Index from './components/Index'
import Login from './components/Login'

export default {
  name: 'App',
  components:{
    Index,
    Login
  }
}
</script>

<style>
  ul{
    list-style: none;
    padding: 0;
    margin: 0
  }
</style>



// WEBPACK FOOTER //
// src/App.vue